import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';

// Public pages
import LoginPage from '../views/public/LoginPage.vue';
import SignupPage from '../views/public/SignupPage.vue';
import GalleryPage from '../views/public/GalleryPage.vue';
import SettingsPage from '../views/public/SettingsPage.vue';

// Private/Admin pages
import AdminPanel from '../views/private/AdminPanel.vue';

// Legacy pages (keeping for compatibility)
import Home from '../views/HomePage.vue';
import About from '../views/AboutPage.vue';
import Form from '../views/FormPage.vue';

const routes = [
  // New application routes
  { path: '/', component: LoginPage },
  { path: '/signup', component: SignupPage },
  { path: '/gallery', component: GalleryPage, meta: { requiresAuth: true } },
  { path: '/settings', component: SettingsPage, meta: { requiresAuth: true } },
  { path: '/admin', component: AdminPanel, meta: { requiresAuth: true, requiresAdmin: true } },
  
  // Legacy routes
  { path: '/home', component: Home },
  { path: '/about', component: About },
  { path: '/form', component: Form }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Navigation guards
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token');
  
  if (to.meta.requiresAuth) {
    if (!token) {
      next('/');
      return;
    }
    
    // Validate token with backend before allowing access
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      const response = await axios.get('https://designappvido-backend.up.railway.app/api/me', config);
      
      // For admin-required routes, check admin status
      if (to.meta.requiresAdmin && !response.data.is_admin) {
        next('/gallery');
        return;
      }
      
      // Token is valid, proceed to route
      next();
    } catch (error) {
      // If token validation fails for any reason (401, network error, etc.), 
      // redirect to login page to ensure security
      localStorage.removeItem('token');
      next('/');
      return;
    }
  } else {
    // No authentication required
    next();
  }
});

export default router;